const merge = require('lodash/merge');
const parseRequestMetaData = require('../../utils/parse-request-meta-data');
const getWs02Token = require('@dbk-legacy/wso2token').getToken;
const SEPERATOR = require('../../utils/constants');

function apiFactory({
  baseUrl,
  requestHandler,
}) {
  const headers = {
    Accept: 'application/json',
  };
  const reqOpts = { headers, method: 'POST', json: true };

  function getUrl(endpoint) {
    return `${baseUrl}${endpoint}`;
  }

  return {
    getUserEntitlement(metaData) {
      const url = getUrl('user-entitlement');
      const parsedMetaData = parseRequestMetaData(metaData);
       const body = {
        userId: parsedMetaData.qs.userId
      }
      return requestHandler(merge(
        reqOpts,
        { url, body },
        parseRequestMetaData(metaData)
      ));
    },

    getPaymentAvailableCheck(metaData) {
      const url = getUrl('processRulesForUserEntitlement');
      const parsedMetaData = parseRequestMetaData(metaData);
       const body = {
        pfId: parsedMetaData.portfolio.pfRelId,
        userId: parsedMetaData.qs.userId,
        branchCode: parsedMetaData.portfolio.branchCode,
      }
      return requestHandler(merge(
        reqOpts,
        { url, body },
        parseRequestMetaData(metaData)
      ));
    },

    getEntitlementUserPfList(metaData){
      const url = getUrl('entitlement-user-pf');
      const parsedMetaData = parseRequestMetaData(metaData);
       const body = {
        userId: parsedMetaData.qs.userId
      }
      const reqOpts = {
        headers: merge(headers, {
          Authorization: getWs02Token()
        }),
        method: 'POST'
      };
      return requestHandler(merge(reqOpts, {
        url,
        body,
        json: true,
        mergeCookies: true
      }));
    },

    getEntitlementsforRM(inputParam, metaData) {
      const url = getUrl('admin-user-entitlement');
     
      const parsedMetaData = parseRequestMetaData(metaData);
      const params = inputParam.split(SEPERATOR.SEPERATOR);
      const roleName = params[0];

       const body = {
        roleName: roleName,
        userId: parsedMetaData.qs.userId
      }
      const reqOptsHeader = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        json: true
      };

      return requestHandler(merge(reqOptsHeader, {
        url,
        body
      }));
      
    }
  };
}

module.exports = apiFactory;
